import { on } from 'delegated-events'
import { slideDown, slideToggle } from '../common/slide'

const fn = {
    init: () => {
        on('click', '.accordion-item .title', fn.handleAccordian)

        var hashTarget = window.location.hash.substring(1)
        if (hashTarget) {
            var targetEl = document.getElementById(hashTarget)
            if (targetEl && targetEl.classList.contains('accordion-item')) {
                targetEl.classList.add('faq-highlight')
                var categoryEl = targetEl.closest('.faq-category')
                if (categoryEl) {
                    categoryEl.classList.remove('hidden')
                    var filter = document.getElementById('faq-category-filter')
                    if (filter) filter.value = categoryEl.dataset.categoryId || ''
                }
                var title = targetEl.querySelector('.title')
                var content = targetEl.querySelector('.accordion-content')
                if (title) {
                    title.classList.remove('closed')
                    var img = title.getElementsByTagName('img')[0]
                    var svg = title.getElementsByTagName('svg')[0]
                    if (img) img.style.transform = 'rotate(180deg)'
                    else if (svg) svg.style.transform = 'rotate(180deg)'
                }
                if (content) {
                    content.classList.remove('hidden')
                    slideDown(content)
                }
                setTimeout(function () {
                    targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }, 100)
            }
        }

    },

    handleAccordian: (e) => {
        e.preventDefault()
        var target = e.target;

        var item = target.closest('.accordion-item')
        var title = target.closest('.title')

        if (title.classList.contains('closed')) {
            title.classList.remove('closed')
            var img = title.getElementsByTagName('img')[0]
            var svg = title.getElementsByTagName('svg')[0]
            if (img) {
                img.style.transform = 'rotate(180deg)';
            } else if (svg) {
                svg.style.transform = 'rotate(180deg)';
            }
        } else {
            title.classList.add('closed')
            var img = title.getElementsByTagName('img')[0]
            var svg = title.getElementsByTagName('svg')[0]
            if (img) {
                img.style.transform = 'rotate(0deg)';
            } else if (svg) {
                svg.style.transform = 'rotate(0deg)';
            }
        }

        var contents = item.getElementsByClassName('accordion-content')
        var content = contents[0]
        slideToggle(content)

    }
}

export default {
    can: () => document.querySelector('.accordion-item'),
    run: fn.init,
}
